import * as React from "react";
import createSvgIcon from "./utils/create_svg_icon";

export default createSvgIcon(
  <path d="m 4.500235,7.65383 -3.3073425,3.307343 v 2.695935 H 13.45 V 14.6 H 0.25 V 1.4 H 1.1928925 V 9.7383575 L 4.500235,6.431015 6.378595,8.3241425 11.564298,3.1383575 13.45,5.0241425 V 6.246875 L 11.564298,4.3611725 6.378595,9.546875 Z" />,

  "Report",
);
